import * as React from "react";
import {useEffect, useState} from "react";
import {IReduxState} from "../reducers";
import {connect} from "react-redux";
import {ILoanApprovalInfo, IOppSubstatus} from "StateInterface";
import {setPaanduProfile} from "profile/actions";
import {getLamProfile} from "profile/api";
import {getActiveOppId, getLatestLoanOpp} from "consent/actions";
import {RouteComponentProps} from "react-router-dom";
import {getConsentRoutes, handleConsentNavigation, RoutePaths, setConsentIndexPath} from "consent/route";
import {RepayRoutePaths} from "consent/repayment/route";
import Loading from "components/loading";

interface IConnectProps {
  loading: boolean;
  loanApprovalInfo: ILoanApprovalInfo;
  lenderOpportunityId: string;
  userId: number;
  dispatch?: (action: any) => void;
  latestStatus: boolean;
  unsignedDocBase64Str: string;
  pathname: string;
}

const urlsToBeReplaced = [
    `${RoutePaths.LOAN_DETAIL}`,
    `${RoutePaths.PA_FORM}`,
    `${RoutePaths.TIMER_DELAY}`,
    `${RoutePaths.CONSENT_COMPLETED}`,
    `${RoutePaths.REPAYMENT}`,
    `${RoutePaths.SHUBHSIGN}`,
    RoutePaths.LOAN_REJECT,
];
export function setRoute(loanApprovalInfo, unsignedDocBase64Str, location, ignoreStatusCheck: boolean) {
  if (loanApprovalInfo != null) {
    if (ignoreStatusCheck && location.pathname.includes(RoutePaths.REDIRECTION)) {
      return RoutePaths.REDIRECTION;
    } else {
        if (loanApprovalInfo.status === "LENDER_APPROVED") {
            return RoutePaths.LOAN_DETAIL;
        } else if (loanApprovalInfo.status === "CUST_CONSENT_GIVEN") {
            if (loanApprovalInfo && loanApprovalInfo.subStatuses
                && loanApprovalInfo.subStatuses.includes(IOppSubstatus.PA_FORM_PENDING)) {
                return RoutePaths.PA_FORM;
            } else if (loanApprovalInfo && loanApprovalInfo.subStatuses &&
              loanApprovalInfo.subStatuses.includes(IOppSubstatus.SHUBHSIGN_PENDING)
                && !unsignedDocBase64Str) {
                return RoutePaths.TIMER_DELAY;
            } else if (loanApprovalInfo && loanApprovalInfo.subStatuses &&
              loanApprovalInfo.subStatuses.includes(IOppSubstatus.SHUBHSIGN_PENDING) && !loanApprovalInfo.isEsignDone) {
                return RoutePaths.SHUBHSIGN;
            } else if (loanApprovalInfo && loanApprovalInfo.subStatuses &&
              loanApprovalInfo.subStatuses.includes(IOppSubstatus.REPAY_INST_PENDING)) {
                if (loanApprovalInfo?.nach && "pnachLink" in loanApprovalInfo.nach && location.pathname.includes(RoutePaths.REPAYMENT + RepayRoutePaths.SCAN)) {
                    return RoutePaths.REPAYMENT + RepayRoutePaths.SCAN;
                } else {
                    return RoutePaths.REPAYMENT;
                }
            } else if (loanApprovalInfo.isEsignDone) {
                return RoutePaths.CONSENT_COMPLETED;
            } else {
                return RoutePaths.CONSENT_ERROR;
            }
        } else if (loanApprovalInfo?.status === "CUST_NOT_INTERESTED" && loanApprovalInfo?.subStatuses?.includes("CONSENT_DENIED")) {
          return RoutePaths.LOAN_REJECT;
        } else {
            return RoutePaths.CONSENT_COMPLETED;
        }
    }
  }
}

type FinalProps = IConnectProps & RouteComponentProps;

function ConsentIndex(props: FinalProps) {
  const [loading, setLoading] = useState(false);
  const getPanduProfile = async () => {
    setLoading(true);
    try {
      const profileResponse = await getLamProfile();
      props.dispatch(setPaanduProfile(profileResponse));
    } catch(e) {}
    setLoading(false);
  }
  
  useEffect(() => {
    props.dispatch(getActiveOppId());
    getPanduProfile();
    setConsentIndexPath(props.match.url);
  }, []);

  useEffect(() => {
    props.lenderOpportunityId && !props.loanApprovalInfo && props.latestStatus && props.dispatch(getLatestLoanOpp(props.lenderOpportunityId));
  }, [props.lenderOpportunityId]);

  useEffect( () => {
    if (!props.latestStatus && props.lenderOpportunityId) {
      props.dispatch(getLatestLoanOpp(props.lenderOpportunityId));
    }
  }, [props.latestStatus, props.lenderOpportunityId]);

  useEffect(() => {
    const ignoreStatusCheck = props.location.pathname.includes(RoutePaths.REDIRECTION);
    const routePath = setRoute(props.loanApprovalInfo, props.unsignedDocBase64Str, props.location, ignoreStatusCheck);
    if (props.latestStatus && routePath && routePath !== props.location.pathname) {
        if ( urlsToBeReplaced.includes(routePath)) {
            handleConsentNavigation(routePath, false);
        } else {
            handleConsentNavigation(routePath, true);
        }

    }
  }, [props.loanApprovalInfo, props.unsignedDocBase64Str]);
  return (
    <div className={"col-md-4 offset-md-4"}>
      <Loading active={props.loading || loading}/>
      <div>
        {getConsentRoutes(props.match.path)}
      </div>
    </div>
  );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        loanApprovalInfo: state.consent.loanApprovalInfo,
        lenderOpportunityId: state.consent.lenderOpportunityId,
        loading: state.consent.loading,
        userId: state.login?.auth?.userId || state.login?.authExt?.userId,
        latestStatus: state.consent.latestStatus,
        unsignedDocBase64Str: state.consent.unsignedDocBase64Str,
        pathname: state.userform.param,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(ConsentIndex);
